import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CadastroIngredientesService {
    public nomeProduto = new BehaviorSubject<string>('');
    public nomeSabor = new BehaviorSubject<string>('');
    public codigoProduto = new BehaviorSubject<number>(0);
    public codigosProdutos = new BehaviorSubject<number[]>([]);
    // Para lasanhas/pizzas, o que será emitido é o nome do sabor ou código?
    // Analisando como o Adicional funciona, criaremos atributos flexíveis.
    
    constructor() { }
}